import React from 'react';
import { string } from 'prop-types';

import PageRow from './../PageRow';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import ButtonForm from 'components/forms/ButtonForm';
import useGlobalState from 'actions';
import {
  activeAccountDialog,
  paymentDialogHeader,
  paymentDialogTxt,
  paymentDialogTxt1,
} from './styles';

function LoanDetailsDialog({ loanXid }) {
  const [globalState, globalActions] = useGlobalState();
  const handleClose = () => {
    globalActions.openLoanDetailsDialog('preOpen', false);
  };

  return (
    <PageRow>
      <Dialog open={globalState.preOpen} className={activeAccountDialog}>
        <DialogTitle id='pi'>
          <div style={{ textAlign: 'center' }} className={paymentDialogHeader}>
            Detail Pembayaran
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{ paddingLeft: '5px', textAlign: 'left' }}
              >
                Loan ID
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{ paddingRight: '5px', textAlign: 'right' }}
              >
                #{loanXid}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Status
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                {localStorage.getItem('selected_status')}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Mulai bayaar
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                {localStorage.getItem('selected_start_pay')}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Total pencairan
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                Rp {localStorage.getItem('selected_disbursed')}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Sisa pembayaran
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                Rp {localStorage.getItem('selected_remaining_payment')}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Cicilan per hari
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                Rp {localStorage.getItem('selected_daily_repayment')}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt}
                style={{
                  paddingLeft: '5px',
                  paddingTop: '15px',
                  textAlign: 'left',
                }}
              >
                Pembayaran berhasil
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={paymentDialogTxt1}
                style={{
                  paddingRight: '5px',
                  paddingTop: '15px',
                  textAlign: 'right',
                }}
              >
                {localStorage.getItem('selected_successful_payment')}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ paddingRight: '5px', paddingTop: '15px' }}>
                <ButtonForm color='primary' onClick={handleClose}>
                  Kembali
                </ButtonForm>
                <br />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </PageRow>
  );
}

LoanDetailsDialog.propTypes = {
  loanXid: string,
};

export default LoanDetailsDialog;
